//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelDeadlines } from "wint-api-client/dist/types";
//#endregion
//#region components
import { ConsequenceDetailsView } from "components/deadline";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useConsequencePreviewDialog(consequences: WintSuperkollAPIModelDeadlines.DeadlineConsequence[]) {
  const getDialogProps = () => {
    const dialog: DialogProps = {
      isOpen: false,
      id: "previewConsequence",
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Consequences),
      titleIcon: IconDefinitionConstants.WInfo,
      dialogType: DialogEnums.DialogType.Content,
      children: <ConsequenceDetailsView consequences={consequences} />,
      hideDivider: true,
      hideCancelButton: true,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Close),
          onClick: async () => {},
        },
      ],
      maxWidth: "sm",
    };

    return dialog;
  };

  return getDialogProps;
}

export default useConsequencePreviewDialog;
